import { useMsal } from '@azure/msal-react';
import { router } from '@src/main/app/router';
import { AuthProvider } from '@src/main/shared/context/AuthContext';
import { ToastProvider } from '@src/main/shared/context/ToastContext';
import { logger } from '@src/main/shared/utils/logger';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FC, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';

const queryClient = new QueryClient();

const App: FC = () => {
  const { instance, accounts } = useMsal();
  const [msalReady, setMsalReady] = useState(false);

  useEffect(() => {
    const initMsal = async () => {
      try {
        await instance.initialize();
      } catch (error) {
        logger.error('MSAL initialization or redirect failed:', error);
      } finally {
        setMsalReady(true);
      }
    };

    initMsal();
  }, [instance, accounts]);

  if (!msalReady) return <ProgressSpinner />;

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
